export default __webpack_public_path__ + "static/media/mem_cert.2070606d.jpg";